import { useDispatch, useSelector } from "react-redux";
import { setModalsData, TModalsState } from "../api/store/commonSlice";
import { useSysadminLoginAsAccountUserMutation } from "../api/network/sysadminApiServices";
import { TLegacyUser } from "../api/types/User";
import { ROLE_ACCESS_LEVELS } from "../pages/admin-details/role/constants";
import { localStorageKeys, useLocalStorage } from "../utils/localStorageItems";
import { useLoggedInUserData } from "../utils/user";
import { ACL_NAMES, useACL } from "./acl";
import { useLoginHandler } from "./loginHandler";

// same-account "Login As" shared by every screen that lists users
export const useLoginAsUser = () => {
  const dispatch = useDispatch();
  const modalsState: TModalsState = useSelector(
    (state: any) => state.commonReducer.modals
  );
  const { getLocalStorageItem } = useLocalStorage();
  const { getUserACLAccessLevel } = useACL();
  const thisUserOrganizationId = useLoggedInUserData("ownerOrganizationId");
  const loginHandler = useLoginHandler({ screen: "loginScreen" });
  const [loginAsUserApiTrigger] = useSysadminLoginAsAccountUserMutation();

  const canLoginAs =
    useLoggedInUserData("userloginasallowed") === "1" &&
    getUserACLAccessLevel(ACL_NAMES.ACL_USER_LOGIN_AS) >=
      ROLE_ACCESS_LEVELS.WRITE;
  const loggedInUserId = (getLocalStorageItem(localStorageKeys.user) as TLegacyUser)
    ?.userid;

  const canLoginAsUser = (userId?: string, isActive?: number) =>
    canLoginAs && isActive === 1 && !!userId && userId !== loggedInUserId;

  const loginAs = (
    e: React.MouseEvent<HTMLElement, MouseEvent> | undefined,
    userId: string
  ) => {
    e?.stopPropagation();
    e?.preventDefault();
    dispatch(setModalsData({ ...modalsState, showPrimaryOverlay: true }));
    loginAsUserApiTrigger({
      user_id: userId,
      account_id: `${thisUserOrganizationId}`,
    })
      .unwrap()
      .then((response) => {
        loginHandler.prepareSwitchSysadminToAccountUser();
        loginHandler.loginSuccessHandler(response);
        window.location.reload();
      })
      .catch(loginHandler.loginErrorHandler)
      .finally(() => {
        dispatch(setModalsData({ ...modalsState, showPrimaryOverlay: false }));
      });
  };

  return { canLoginAs, canLoginAsUser, loginAs };
};
